module.exports = __webpack_public_path__ + "assets/img/9fa60afc91b1ccfce0b7a69f0b5ba52f.webp";